/**
 * DE CUANDO ES CADA NUMERO DE LA SALA DE MAQUINAS (SALA-ARQ-VISTA-T1, MODALIDAD-TRABAJO-V2 mecanismo M6, lado panel).
 *
 * DE DONDE SALE. El dial de arquitectura decia "Medido hoy" sobre numeros de septiembre: la vista calculaba la edad con
 * `generado`, que es CUANDO SE ARMO LA RESPUESTA (cache de 60 s), no cuando se tomo la foto. La API ya mandaba la fecha
 * de verdad desde SNAP-VIVO-T1 (SaludTableroDto.Foto: arquitectura, arquitecturaDiasAtras, ultimaFoto...) con la nota
 * "Argy-P tiene que pintarlo", y el panel nunca la leyo.
 *
 * LAS REGLAS:
 *   1. la edad de la arquitectura sale de foto.arquitecturaDiasAtras (o de foto.arquitectura contra foto.hoy); NUNCA de
 *      `generado`; sin fecha es "sin fecha", no "hoy"
 *   2. mas de 7 dias = VENCIDO: el dial no muestra el color del valor (rojo y la palabra vencido) y cuenta como falla;
 *      de 3 a 7 = vieja (aviso); 0 a 2 = fresca
 *   3. el "Medido" del pie dice la fecha del dato MAS VIEJO de lo que se pinta, no la hora de la pantalla
 *
 * Sin DOM: lo prueba scripts/check-salud-frescura.mjs.
 */

export const DIAS_PARA_VENCER = 7;
export const DIAS_PARA_AVISAR = 2;

const fechaDe = (s) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s ?? ''));
  return m ? Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

/** Dias que tiene la foto de arquitectura, o null si no se sabe. */
export function diasDeLaArquitectura(foto) {
  const n = foto?.arquitecturaDiasAtras;
  if (n !== null && n !== undefined && n !== '' && Number.isFinite(Number(n))) return Math.max(0, Number(n));
  const f = fechaDe(foto?.arquitectura), h = fechaDe(foto?.hoy);
  if (f === null || h === null) return null;
  return Math.max(0, Math.round((h - f) / 86400000));
}

/** 'fresca' | 'vieja' | 'vencido' | 'sin_fecha' */
export function estadoDeFrescura(dias) {
  if (dias === null || dias === undefined || !Number.isFinite(Number(dias))) return 'sin_fecha';
  if (dias > DIAS_PARA_VENCER) return 'vencido';
  if (dias > DIAS_PARA_AVISAR) return 'vieja';
  return 'fresca';
}

/** La frase de cuando es: "Medido hoy.", "Medido hace 28 dias (2026-09-08).", o que no se sabe. */
export function fraseDeCuando(foto) {
  const dias = diasDeLaArquitectura(foto);
  if (dias === null) return 'No se sabe de cuando es esta foto.';
  const fecha = foto?.arquitectura ? ` (${String(foto.arquitectura).slice(0, 10)})` : '';
  return dias === 0 ? `Medido hoy${fecha}.` : dias === 1 ? `Medido ayer${fecha}.` : `Medido hace ${dias} dias${fecha}.`;
}

/**
 * El "Medido" del pie: la fecha del dato MAS VIEJO que se pinta. Agentes y cola se calculan al vuelo (son de
 * `generado`); la arquitectura es de su foto. -> {fecha, de} o null.
 */
export function medidoDelPie(d) {
  const candidatos = [];
  if (d?.foto?.arquitectura) candidatos.push({ fecha: String(d.foto.arquitectura).slice(0, 10), de: 'arquitectura' });
  if (d?.generado) candidatos.push({ fecha: String(d.generado).slice(0, 10), de: 'agentes y cola' });
  const conFecha = candidatos.filter((c) => fechaDe(c.fecha) !== null);
  if (!conFecha.length) return null;
  return conFecha.reduce((a, b) => (fechaDe(b.fecha) < fechaDe(a.fecha) ? b : a));
}
